.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  min-height: 0;
  height: 100%;
  min-width: 0;
  width: 100%;
  scroll-behavior: smooth;
  border-left: 1px var(--content-border-color) solid;
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem;

  @media screen and (min-width: $bp-medium) {
    padding: 1.2rem;

    &:first-child {
      border-bottom: 0.1rem solid var(--color-grayscale-trout);
    }
  }
}

.title {
  font-size: 1.2rem;
  font-weight: 400;
  color: var(--color-grayscale-white);

  @media screen and (min-width: $bp-medium) {
    font-size: 1.4rem;
  }
}

.is-completed-label {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  font-size: 1.2rem;
  font-weight: 400;
  color: var(--color-grayscale-manatee);

  @media screen and (min-width: $bp-medium) {
    font-size: 1.4rem;
  }
}

.footer {
  margin: 0.8rem 0.8rem 2rem;
  bottom: 0;
  position: fixed;
  width: calc(100% - 1.6rem);

  @media screen and (min-width: $bp-medium) {
    padding: 1.6rem 0.8rem 2.4rem;
    margin: 2rem 0 0;
    border-top: 0.1rem solid var(--color-grayscale-trout);
    position: unset;
    min-height: unset;
    width: 100%;
  }
}
